import { Box, Button, Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import { FaPen, FaRegTimesCircle } from "react-icons/fa";

function CardAddressDelivery({
  deliveryAddress,
  IsEditingAddress,
  setIsEditingAddress
}) {
  const Wide = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });
  return (
    <Flex
      mt={"14px"}
      mx={"10px"}
      h={Wide ? "100px" : "70px"}
      maxW={Wide && "500px"}
      bgColor={"gray.100"}
    >
      <Box h={"full"} width={Wide ? "full" : "305px"} p={"8px 14px 20px"}>
        <Text
          as="h4"
          fontWeight={"medium"}
          fontSize={Wide ? "20px" : "14px"}
          color={"gray.700"}
        >
          ENDERÇO DE ENTREGA
        </Text>
        <Text fontSize={Wide ? "14px" : "12px"} fontWeight={"regular"}>
          {`${deliveryAddress?.rua ?? "..."}, ${
            deliveryAddress?.numero ?? "..."
          }, ${deliveryAddress?.cep ?? "..."}`}
        </Text>
        <Text fontSize={Wide ? "14px" : "12px"} fontWeight={"regular"}>
          {`${deliveryAddress?.bairro ?? "..."}, ${
            deliveryAddress?.cidade ?? "..."
          } - ${deliveryAddress?.uf ?? "..."}`}
        </Text>
      </Box>
      <Button
        variant={"unstyled"}
        h={"full"}
        width={"50px"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        borderRadius={"0"}
        border="1px solid"
        color={"gray.400"}
        borderColor={"gray.100"}
        bgColor={"white"}
        ml={Wide && "auto"}
        onClick={() => setIsEditingAddress(!IsEditingAddress)}
        _focus={{
          border: "1px solid",
          borderColor: "red.300"
        }}
      >
        <Text>{IsEditingAddress ? <FaRegTimesCircle /> : <FaPen />}</Text>
        <Text fontWeight={"medium"} fontSize={"11px"} color={"#444444"}>
          {IsEditingAddress ? "Fechar" : "Editar"}
        </Text>
      </Button>
    </Flex>
  );
}

export { CardAddressDelivery };
